import useLessonSelector from "redux/selectors/lessons";

import { Modal } from "components/Shared/Modal";
import { Button } from "components/Shared/Button";
import { useAuthSelectors } from "redux/selectors";
import { Roles } from "redux/reducers/authSlice";
import {
  RESERVATION_TYPES,
  setReservingLesson,
} from "redux/reducers/reservationsSlice";
import { useAppDispatch } from "redux/store/hooks";
import RoutePaths from "routes/RoutePaths";
import { useHistory } from "react-router-dom";
import React, { Fragment, useState } from "react";
import "./styles.scss";
import { modal_close } from "assets/images/";
import { Typography } from "components/Shared/Typography";
import { getUserTotalPoints } from "redux/actions/reservations";
import { LessonMode } from "features/lessons/models";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ILessonMode } from "../../../../types/components/expertView";
import { ITopic } from "../../../../types/redux/expert";
import TopicsDescription from "../../ExpertCard/topicsDescription";
import moment from "moment";
import DateAndTime from "../../ExpertCard/DateAndTime";

interface Props {
  isLessonInfoModalOpen: boolean;
  selectedLessonType: string;
  onCloseHandler: () => void;
}

const LessonInfoPopup = ({
  isLessonInfoModalOpen = false,
  selectedLessonType,
  onCloseHandler,
}: Props) => {
  const { selectedLesson } = useLessonSelector();
  const { selectAuthUser } = useAuthSelectors();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { push } = useHistory();
  const [isNotEnoughPointsModalOpen, setIsNotEnoughPointsModalOpen] =
    useState<boolean>(false);

  const proceedReservationHandler = async () => {
    const requiredPoints = calculateTotalLessonPoints();
    const availablePoints = await dispatch(getUserTotalPoints()).unwrap();

    if (availablePoints < requiredPoints) {
      setIsNotEnoughPointsModalOpen(true);
      return false;
    }

    if (selectedLesson?.lesson_type === 2) {
      if (selectedLesson?.topics) {
        dispatch(setReservingLesson(RESERVATION_TYPES.GROUP_LESSON_PACK));
      } else {
        dispatch(setReservingLesson(RESERVATION_TYPES.GROUP_LESSON_SINGLE));
      }
      push(RoutePaths.reservation);
    } else {
      push(RoutePaths.studentSelectTimeSlot);
    }
  };

  const calculateTotalLessonPoints = () => {
    return selectedLessonType === LessonMode.SINGLE
      ? selectedLesson.points
      : selectedLesson.topics?.length * selectedLesson.points;
  };

  const purchasePageHandler = () => {
    push(RoutePaths.studentPurchasePoints);
  };

  const MainModal = () => (
    <BaseModal openIf={isLessonInfoModalOpen} onClose={onCloseHandler}>
      {selectedLesson && (
        <div className="modal_content">
          <Typography className="sub_heading" variant="" component="div">
            {selectedLesson.lesson_name}
            {selectedLesson?.schedule?.schedule_date &&
              selectedLesson?.schedule?.schedule_time && (
                <DateAndTime
                  date={selectedLesson.schedule.schedule_date}
                  time={selectedLesson.schedule.schedule_time}
                />
              )}
          </Typography>

          <Typography className="lesson_info_area" variant="" component="div">
            {selectedLesson.lesson_mode === ILessonMode.SINGLE ? (
              <span>{selectedLesson?.description}</span>
            ) : (
              selectedLesson.topics.map(
                (
                  topic: {
                    topic: ITopic;
                    schedule_date?: string;
                    schedule_time?: string;
                  },
                  index: number
                ) => (
                  <TopicsDescription
                    topic={topic.topic.topic}
                    key={topic.topic.id}
                    description={topic.topic.description}
                    index={index}
                    date={topic.schedule_date}
                    time={topic.schedule_time}
                  />
                )
              )
            )}
          </Typography>
          <ul>
            <li>
              <span className="title">
                {t("lessons.lessonPopup.label.Category")}
              </span>
              <span className="description">
                {selectedLesson.category.name}
              </span>
            </li>
            <li>
              <span className="title">
                {t("lessons.lessonPopup.label.Country")}
              </span>
              <span className="description">
                {t("countries." + selectedLesson.country.name)}
              </span>
            </li>
            <li>
              <span className="title">
                {t("lessons.lessonPopup.label.Language")}
              </span>
              <span className="description">
                {" "}
                {selectedLesson.language[0].name}{" "}
              </span>
            </li>
            <li style={{ flexDirection: "column" }}>
              <div style={{ display: "flex" }}>
                <span className="title">
                  {t("lessons.lessonPopup.label.NoOfLessons")}
                </span>
                <span className="description">
                  {selectedLessonType === LessonMode.SINGLE
                    ? 1
                    : selectedLesson.topics?.length}
                  {/* {selectedLessonType} */}
                </span>
              </div>
              <div style={{ marginLeft: "20px" }}>
                {selectedLessonType === LessonMode.PACK &&
                  selectedLesson?.topics?.topic?.map(
                    // selectedLesson?.topics?.map(
                    (topic: any, i: number) => (
                      <p className="lessons">
                        Lesson {i + 1} : {topic.topic}
                      </p>
                    )
                  )}
              </div>
            </li>
            <li>
              <span className="title">
                {t("lessons.lessonPopup.label.Type")}
              </span>
              <span className="description">
                {selectedLesson.lesson_type === 1
                  ? t("common.individual")
                  : t("common.group")}
              </span>
            </li>
            <li>
              <span className="title">
                {t("lessons.lessonPopup.label.Length")}
              </span>
              <span className="description">
                {" "}
                30 {t("common.min")} / {t("common.lesson")}
              </span>
            </li>
            <li>
              <span className="title">
                {t("lessons.lessonPopup.label.NoOfPoints")}
              </span>
              <span className="description">
                {selectedLessonType === LessonMode.SINGLE
                  ? selectedLesson.points
                  : selectedLesson.topics?.length * selectedLesson.points}
              </span>
            </li>
            {selectedLesson.lesson_type === 2 &&
              selectedLessonType === LessonMode.SINGLE && ( // ! group - single lessons only
                <Fragment>
                  <li>
                    <span className="title">
                      {t("lessons.lessonPopup.label.Date")}
                    </span>
                    <span className="description">
                      {" "}
                      {new Date(
                        selectedLesson?.schedule?.schedule_date
                      ).toLocaleDateString()}{" "}
                    </span>
                  </li>
                  <li>
                    <span className="title">
                      {t("lessons.lessonPopup.label.Time")}
                    </span>
                    <span className="description">
                      {" "}
                      {new Date(
                        selectedLesson?.schedule?.schedule_time
                      ).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}{" "}
                    </span>
                  </li>
                </Fragment>
              )}
          </ul>
          {selectAuthUser?.currentRole === Roles.student && (
            <Button
              id="copy-schedule-button"
              // label={"Proceed to Reservation =? check points here"}
              label={t("lessons.lessonPopup.label.ProceedButton")}
              onClick={proceedReservationHandler}
            />
          )}
        </div>
      )}
      {!selectedLesson && (
        <Box className="loading_circular">
          <CircularProgress size={20} color={"warning"} />
        </Box>
      )}
    </BaseModal>
  );

  const NotEnoughPointsModal = () => (
    <BaseModal openIf={isNotEnoughPointsModalOpen} onClose={onCloseHandler}>
      <div className="modal_content">
        <h3>{t("lessons.lessonPopup.label.noEnoughPoints")}</h3>
        <div className="btn-area">
          <Button
            id="btn-purchase-page"
            label={t("lessons.lessonPopup.label.purchaseBtn")}
            onClick={purchasePageHandler}
            customStyles="mtop"
          />
        </div>
      </div>
    </BaseModal>
  );

  if (isNotEnoughPointsModalOpen) {
    return NotEnoughPointsModal();
  }
  return MainModal();
};

interface BaseModalProps {
  children: React.ReactNode;
  openIf: boolean;
  onClose: () => void;
}

const BaseModal = ({ children, openIf, onClose }: BaseModalProps) => (
  <Modal id="create-schedule" open={openIf}>
    <div onClick={onClose} className="modal_close_div">
      <img src={modal_close} className="modal_close" alt="Modal Close Button" />
    </div>
    {children}
  </Modal>
);

export default LessonInfoPopup;
